import ListViewModel from "@vm/List/ListViewModel";
import Project from "@model/Project";

import { inject, injectable } from "inversify";

import TYPES from "../../inversify.types";

// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class ProjectListVM extends ListViewModel<Project, Repository<Project>> {
  constructor(@inject(TYPES.ProjectRepository) repository: Repository<Project>) {
    super(repository);
  }
}
